import React from "react";
import '../../components/bracket/BracketDisplay.css';
import ViewOnlyBracketContainer from "./ViewOnlyBracketContainer";
import HomeControl from "components/reusable/HomeControl";
import withRouter from "pages/withRouter";

class ViewBracketPage extends React.Component {

  constructor(props){
    super(props);

    this.state = {
      //setup
      displaySettingsPanel: false,
      displayPublishPanel: false,
      hideByes: false,
      isLoading: false,
      viewOnlyBracketId: null,
      bracketId: this.props?.params?.bracketId
    };

  }

  render(){
    return (
      <div className="view-only-brackets">
      {/* <HomeControl></HomeControl> */}
        <div className="breadcrumb-container">
          <div className="tail-container"><div className="left-tail-container"></div></div>
          <div className="view-only-breadcrumb">View Only</div>
          <div className="tail-container"><div className="right-tail-container"></div></div>
        </div>
        <ViewOnlyBracketContainer format="tournament" saveBrackets={this.saveBrackets} bracketId={this.state.bracketId}></ViewOnlyBracketContainer>
      </div>
    )
  }
}

export default withRouter(ViewBracketPage);
